import { FormProvider } from '@/context/FormProvider';

import {
  type CreateKnowledgeBaseFormValues,
  createKnowledgeBaseSchema,
} from '@/schemas/knowledge-base.schema';

type Props = {
  children: React.ReactNode;
  onSubmit: (values: CreateKnowledgeBaseFormValues) => void;
};

export const CreateKnowledgeBaseFormProvider = ({ children, onSubmit }: Props) => {
  const initialValues: CreateKnowledgeBaseFormValues = {
    name: '',
    kb_description: '',
  };

  return (
    <FormProvider
      initialValues={initialValues}
      validationSchema={createKnowledgeBaseSchema}
      onSubmit={onSubmit}
    >
      {children}
    </FormProvider>
  );
};
